import { CommonModule } from "@angular/common";
import { Component, Input, OnDestroy, OnInit, TemplateRef } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsModalService } from "ngx-bootstrap/modal";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { BehaviorSubject, debounceTime, distinctUntilChanged, Observable, Subject, Subscription } from "rxjs";
import { TruncatePipe } from "src/app/pipe/TruncatePipe.pipe";
import { ApiService } from "src/app/services/api.service";
import { AppSettings } from "src/app/services/AppSettings";
import { GigsumoConstants } from "src/app/services/GigsumoConstants";
import { UtilService } from "src/app/services/util.service";
import { User } from "src/app/types/User";
import { UserCardConfig } from "src/app/types/UserCardConfig";
import Swal from "sweetalert2";
import { CommonSkeletonComponent } from "../../../skeleton/common-skeleton/common-skeleton.component";
import { NodataFoundComponent } from "../../../widget/nodata-found/nodata-found.component";
import { UserCardComponent } from "../../cards/user-card/user-card.component";
import { BusinessEmployeeRequestsComponent } from "./../business-employee-requests/business-employee-requests.component";
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: "app-business-employee",
  standalone: true,
  imports: [BsDropdownModule, 
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    TruncatePipe,
    CommonSkeletonComponent,
    UserCardComponent,
    NodataFoundComponent
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./business-employee.component.html",
  styleUrls: ["./business-employee.component.scss"],
})
export class BusinessEmployeeComponent implements OnInit, OnDestroy {
  /** Wireframe list header (title + count, full-width search pill); false = old Bnav header. */
  useWireframeHeader = true;
  // clickEventsubscription: Subscription;
  //   values = {businessId:"",  admin: false,employees:[]  ,
  //   menu:"", userId:"",follower:false
  //  }

  @Input() commonemit;
  values: any = {};
  modalRef: any;
  term: string;
  // basicDeatils;
  userData: Array<any> = [];
  removedatas;
  name;
  empSearch: any;
  tempemployee: any;
  noDatafound: Array<string> = ["No data to display!"];
  showNoDatafound: boolean = false;
  // isAdmin;
  // isSuperAdmin;
  AllRevokeData: boolean = false;
  revokedData;
  loadAPIcallValue: boolean
  //Abu
  serachForm: UntypedFormGroup;
  userList: any = [];
  firstList: any;
  formCtrlSub: Subscription;
  subject: Subject<any> = new Subject();
  berequest: BusinessEmployeeRequestsComponent;
  //Usercard initialization;
  userCardConfig: UserCardConfig[] = [];
  searchKey;
  businessData: any;

  businessEmployees: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([])
  employeepayload =
     {
      limit : 10,
      businessId:null,
      type:"All",
      searchAfterKey:null,
      searchContent :null
    }
    search: any;
    stopScroll : boolean = false;
    previouseAfterKey : any = null;
    searchSubject = new Subject<string>();
    scrollSubject = new BehaviorSubject<string>(null);
    loadScroll : boolean = false;
    totalCount: number;
    searchContent: any;
    currentUserId: string;

  constructor(
    private API: ApiService,
    private util: UtilService,
    private modalService: BsModalService,
    private router: Router,
    // private commonvalues: CommonValues,
    private fb: UntypedFormBuilder,
    private _activated_route: ActivatedRoute
  ) {
    // this.clickEventsubscription = this.commonvalues
    //   .getbusinessid()
    //   .subscribe((res) => {
    //     this.values = res;
    //     this.basicDeatils = res.basicDeatils;
    //   });
  }

  responseReceived: boolean = false;
  ngOnInit() {
    this._activated_route.queryParams.subscribe(res => {
      this.businessData = res;

    })
    this.API.loadAPIcallValue$.subscribe(value => {
      this.loadAPIcallValue = value;
    });
    this.currentUserId = localStorage.getItem("userId");
    // this.values = this.commonemit;
    // this.isAdmin = localStorage.getItem("isAdmin");
    // this.isSuperAdmin = localStorage.getItem("isSuperAdmin");

    // if (this.isSuperAdmin) {
    //   this.isAdmin = this.isSuperAdmin;
    // }

    //abu
    this.formserchData();
    this. getEmployees();

    // Initialize button configuration for all users
    this.initializeButtonConfig();

    // Handling search input with debounce to optimize requests and updating the search results by naaz
      this.searchSubject.pipe(
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe(res=>{
        this.loadScroll = false;
        this.responseReceived=false;
        this.resetPayload();
        this.employeepayload.searchContent = res;
        this.getEmployees();
      });

      // Handling scroll events with debounce to load more data when scrolling by naaz
      this.scrollSubject.pipe(
            debounceTime(100),
            distinctUntilChanged()
          ).subscribe(res=>{
            if(res!=null){
              this.employeepayload.searchAfterKey = this.previouseAfterKey;
              this.getEmployees();
            }
          })
  }
// Fetching employee data, handling scroll logic, updating employee list by naaz
  getEmployees(){
    this.userList=[];
    this.showNoDatafound = false;
    this.employeepayload.businessId = this.businessData?.businessId ?? null;
    this.fetchEmployees()
    .subscribe(res => {
      this.responseReceived = false;
      this.loadScroll = false;
      if (res) {
        this.responseReceived = true;

        if (res.code === GigsumoConstants.SUCESSCODE) {
         
          const data = res.data.businessEmployees;
          const searchAfterKey = res.data.searchAfterKey;

          if((data && data.length === 0) || JSON.stringify(this.previouseAfterKey) === JSON.stringify(searchAfterKey)){
            this.stopScroll = true;
          }
          if(data){

          const current = data.map(element => {
            // element[this.employeepayload.type === 'REVOKED' ? "revokedUser" : ""] = true
            if(this.employeepayload.type === "REVOKED"){
              element.deniedUser = true;
            }
            element.showAccept = false;
            
            // Set connection status based on user relationship
            this.setConnectionStatus(element);
            
            return element;
          });

          const exist = this.businessEmployees.getValue();
          // Prevent duplicates by checking userId
          const filteredCurrent = current.filter(newEmployee =>
           !exist.some(existingEmployee => existingEmployee.userId === newEmployee.userId)
           );
          const combined = [...this.businessEmployees.value , ...filteredCurrent];

          this.businessEmployees.next(combined);
          this.previouseAfterKey = searchAfterKey;

            this.userList = this.businessEmployees.getValue();
          }
          if(res.data.totalCount !== undefined){
            // this.totalCount = res.data.totalCount;
            this.totalCount = res?.data?.totalCount ?? res?.data?.BusinessManageEmployess?.length ?? 0;
          } else if (this.employeepayload.searchAfterKey == null) {
            // Fresh (page-1) load whose response carries NO totalCount — e.g. a
            // search with zero matches — would otherwise keep the stale count.
            // Use what was actually loaded. Scroll pages (searchAfterKey set)
            // are excluded so a missing total there can't clobber the real one.
            this.totalCount = this.businessEmployees.getValue().length;
          }
          this.showNoDatafound = this.businessEmployees.getValue().length === 0;
        // this.values.employees = res.data.businessEmployees;
        // this.employeequary(res.data.businessEmployees);
       
      }
    }
    })

  }
// Resetting payload and scroll-related properties by Naaz
  resetPayload(){
    this.businessEmployees.next([]);
    this.employeepayload.searchAfterKey = null;
    this.previouseAfterKey = null;
    this.stopScroll = false;
  }

  fetchEmployees(): Observable<any> {
    return this.API.create("business/findBusinessEmployees", this.employeepayload);
  }

  fetchBusinessDetail(): Observable<any> {
    if (this.businessData.businessId) {
      return this.API.query('business/details/' + this.businessData.businessId)
    }
  }

  ngOnDestroy(): void {
    // if (this.clickEventsubscription) {
    //   this.clickEventsubscription.unsubscribe();
    // }
    if (this.formCtrlSub) {
      this.formCtrlSub.unsubscribe();
    }
    this.searchSubject.unsubscribe();
    this.scrollSubject.unsubscribe();
  }

  popupdata(popup, data) {
    this.removedatas = data;
    this.PopupServicevlaues(popup);
  }

  canShow(data, source): boolean {
    return false;
  }

  // Set connection status for each employee
  setConnectionStatus(employee: any) {
    // Both Employee and SuperAdmin can send connection requests
    if (!employee.connectionStatus) {
      employee.connectionStatus = "NOT_CONNECTED";
    }
    
    // If requestedBy is not provided by API, we need to handle it
    // The logic in user-card component will use the requestedBy field to determine button visibility
    // For now, ensure the field exists even if empty
    if (!employee.requestedBy) {
      employee.requestedBy = null;
    }
    
    // Convert REQUEST_SENT status to REQUEST_RECEIVED when current user is the receiver
    if (employee.connectionStatus === "REQUEST_SENT" && employee.requestedBy && employee.requestedBy !== this.currentUserId) {
      employee.connectionStatus = "REQUEST_RECEIVED";
    }
    
    // Set helper flags for UI (these are optional and can be used by templates)
    if ((employee.connectionStatus === "REQUEST_PENDING" || employee.connectionStatus === "REQUEST_RECEIVED") && employee.requestedBy !== this.currentUserId) {
      employee.showAcceptRequest = true;
    }
    
    if (employee.connectionStatus === "CONNECTED") {
      employee.showSendMessage = true;
    }
  }

  employeRevoke() {
    let datas: any = {};
    datas.id = this.businessData.businessId;
    datas.type = "REVOKED";
    this.API.create("business/filter/employees", datas).subscribe((res) => {
      res.data.filterEmployeesAndAdminList.forEach((element) => {
        if (element.userId === localStorage.getItem("userId")) {
          element.joinedOn = new Date();
        }
        element.userName = element.firstName + " " + element.lastName;
        element.type = element.businessUserType;
      });
      this.values.employees = res.data.filterEmployeesAndAdminList;
      this.AllRevokeData = true;
    });
    this.userCardConfig = [];
    let accept: UserCardConfig = new UserCardConfig(
      "Accept",
      this.accept,
      this.canShowAccept,
      false  // false = dropdown menu (three-dot menu)
    );
    accept.source = this;
    this.userCardConfig.push(accept);
  }
  accept(user: User) {
    this.util.startLoader();
    let data: any = {};
    data.businessId = this.businessData.businessId;
    data.userId = user.userId;
    data.type = "REVOKED";
    // /business/employee/request/accept - accept employee from request - {'userId': '', 'businessId': ''}
    this.API.create("business/employee/request/accept", data).subscribe(
      (res) => {
        if (res.code == "00000") {
          this.applyFilter("REVOKED");
          // this.fetchEmployees()
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Employee added successfully",
            // text: 'Employee added successfully',
            showConfirmButton: false,
            timer: 2000,
          });
          // this.empCount()
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Oops..",
            text: "Something went wrong. Please try again later.",
            showConfirmButton: false,
            timer: 3000,
          });
        }
        this.util.stopLoader();
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }

  admin: boolean = false;
  filterName: string = "All";
  // filterTeam(val: string) {
  //   let datas: any = {};
  //   if (val == "All") {
  //     datas.businessId = this.businessData.businessId;
  //     this.API.create("business/findBusinessEmployees", datas).subscribe((res) => {
  //       if (res != null) {
  //         this.values.employees = res.data.businessEmployees;
  //         this.employeequary(res.data.businessEmployees);

  //       }
  //       if (this.businessData.isSuperAdmin == 'true') {
  //         this.userCardConfig = [];
  //         let revokeBtn: UserCardConfig = new UserCardConfig(
  //           "Revoke",
  //           this.removedata,
  //           this.canShow,
  //           true
  //         );
  //         revokeBtn.source = this;
  //         this.userCardConfig.push(revokeBtn);

  //       }
  //     });
  //   } else if (val == "ADMIN") {
  //     datas.id = this.businessData.businessId;
  //     datas.type = val;
  //     this.API.create("business/findBusinessEmployees", this.employeepayload).subscribe((res) => {
  //       this.values.employees = res.data.businessEmployees;
  //       this.employeequary(res.data.businessAdminList);
  //     });
  //   } else if (val == "REVOKED") {
  //     datas.type = val;
  //     this.employeepayload.businessId = this.businessData?.businessId ?? null;
  //     this.API.create("business/findBusinessEmployees", this.employeepayload).subscribe((res) => {
  //       this.values.employees = res.data.filterEmployeesAndAdminList;
  //     });
  //     this.userCardConfig = [];
  //     let accept: UserCardConfig = new UserCardConfig(
  //       "Accept",
  //       this.accept,
  //       this.canShow,
  //       true
  //     );
  //     accept.source = this;
  //     this.userCardConfig.push(accept);
  //   }
  //   let [first, ...rest] = val;
  //   this.filterName = first + rest.join("").toLowerCase();
  // }




   // Applying filters based on the value of val, updating filterName, status, and reloading by Naaz
  applyFilter(val : string){
    this.loadScroll = false;
    this.responseReceived = false; 
    
    // Update filter name
    this.updateFilterName(val);
    
    // Set the payload type
    this.employeepayload.type = val;

    // Update button configuration based on filter
    this.updateButtonConfigForFilter(val);

    // Reset and reload data
    this.resetPayload();
    this.getEmployees();
  }

  // Update filter name display
  private updateFilterName(val: string) {
    if (val === "ADMIN") {
      this.filterName = "Admin";
    } else if (val === "REVOKED") {
      this.filterName = "Revoked";
    } else {
      this.filterName = val;
    }
  }

  // Initialize button configuration for all users
  private initializeButtonConfig() {
    this.userCardConfig = [];
    
    if (this.businessData.isSuperAdmin == "true") {
      // SuperAdmin gets Revoke button in dropdown for "All" filter by default
      this.addRevokeButton(false); // false = dropdown menu
    }
    // Regular employees get connection buttons handled automatically by user-card component
  }

  // Update button configuration based on current filter
  private updateButtonConfigForFilter(filterType: string) {
    this.userCardConfig = [];
    
    if (this.businessData.isSuperAdmin == "true") {
      // SuperAdmin button logic
      if (filterType === "REVOKED") {
        // For revoked filter, show Accept in three-dot menu (dropdown)
        this.addAcceptButton(false); // false = dropdown menu
      } else if (filterType === "All") {
        // For All filter, show Revoke in dropdown
        this.addRevokeButton(false); // false = dropdown menu
      } else if (filterType === "ADMIN") {
        // For Admin filter, show Revoke in dropdown
        this.addRevokeButton(false); // false = dropdown menu
      }
    }
    // For regular employees, connection buttons are handled by user-card component automatically
  }

  // Helper method to add Revoke button
  private addRevokeButton(isPrimary: boolean) {
    let revokeBtn: UserCardConfig = new UserCardConfig(
      "Revoke",
      this.removedata,
      this.canShowRevoke,
      isPrimary
    );
    revokeBtn.source = this;
    this.userCardConfig.push(revokeBtn);
  }

  // Helper method to add Accept button
  private addAcceptButton(isPrimary: boolean) {
    let acceptBtn: UserCardConfig = new UserCardConfig(
      "Accept",
      this.accept,
      this.canShowAccept,
      isPrimary
    );
    acceptBtn.source = this;
    this.userCardConfig.push(acceptBtn);
  }

  // Show accept button for SuperAdmin in Revoked filter (for revoked employees)
  // This Accept button is for re-accepting revoked employees, independent of connection status
  canShowAccept(data, source): boolean {
    return source.businessData.isSuperAdmin === 'true' && 
           data.userId !== source.currentUserId && 
           source.employeepayload.type === 'REVOKED';
  }

  // Show revoke button only for SuperAdmin (always visible in three-dot menu)
  canShowRevoke(data, source): boolean {
    return source.businessData.isSuperAdmin === 'true' && data.userId !== source.currentUserId;
  }

  // Show connect button based on connection status
  canShowConnect(data, source): boolean {
    if (data.userId === source.currentUserId) {
      return false; // Don't show connect button for self
    }
    return data.connectionStatus === "NOT_CONNECTED" || !data.connectionStatus;
  }

  // Show cancel request button only for user who sent the request
  canShowCancelRequest(data, source): boolean {
    return data.connectionStatus === "REQUEST_SENT" && data.requestedBy === source.currentUserId;
  }

  // Show accept request button only for user who received the request
  canShowAcceptRequest(data, source): boolean {
    return data.connectionStatus === "REQUEST_PENDING" && data.requestedBy !== source.currentUserId;
  }

  // Show send message button for connected users
  canShowSendMessage(data, source): boolean {
    return data.connectionStatus === "CONNECTED";
  }

  modeltext:string;
  memberShipType= localStorage.getItem("MemberShipType");
  removedata(data) {
    if (this.memberShipType == "Free") {
      this.modeltext = "<p>This employee will be removed from this business page.</p>"
    } else if (this.memberShipType != "Free"){
      // If user other plan we are showing this msg, and if user under free we are showing second msg;
      this.modeltext = `
  <div style="text-align: left; font-size: 14px; line-height: 1.5;">
    <p> This employee will be removed from this  business page </p>
    <p>
       All jobs/candidates owned by this employee will be transferred to you in 
       <b> Onhold/Unavailable </b> status.
    </p>
  </div> `;
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        html: this.modeltext,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        allowOutsideClick: false, 
        allowEscapeKey: false,
        focusCancel: true,
        cancelButtonText: "Cancel",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          let datas: any = {};
          datas.businessId = this.businessData.businessId;
          datas.userId = data.userId;
          this.util.startLoader();
          this.API.create("business/revoke/employee", datas).subscribe(
            (res) => {
              this.util.stopLoader();
              if (res.code == "00000") {
                this.getEmployees();
                // this.fetchEmployees()
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Employee revoked",
                  text: "Employee has been revoked",
                  showConfirmButton: false,
                  timer: 2000,
                }).then(()=>{
                  const currentEmployees = this.businessEmployees.getValue();
                  const updatedEmployees = currentEmployees.filter(employees => employees.userId !== data.userId);
                  this.businessEmployees.next(updatedEmployees);
                  this.userList = updatedEmployees.length;
                  this.totalCount = Math.max(0, this.totalCount - 1);
                })
              }
            },
            (err) => {
              this.util.stopLoader();
              if (err.status == 500) {
                this.util.stopLoader();
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong while processing your request. Please, try again later.",
                  showDenyButton: false,
                  confirmButtonText: `ok`,
                });
              }
            }
          );
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          // Swal.fire({
          //   position: "center",
          //   icon: "success",
          //   title: "Employee is safe",
          //   showConfirmButton: false,
          //   timer: 1500,
          // });
        }
      });
  }

  modalclose() {
    // for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
    //   this.modalService.hide(i);
    // }
    this.modalRef.hide();
  }

  PopupServicevlaues(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
    });
  }

  onsearch(val) {
    if (val != undefined) {
      val = val.trim().toLowerCase();
    }

    var datapass = [];
    datapass = this.values.tempemployees;
    this.values.employees = this.values.tempemployees;
    // this.commonvalues.businessid(this.values);

    if (this.values.employees != null) {
      let empdata = this.filterByString(datapass, val);
      this.values.employees = empdata;
      // this.commonvalues.businessid(this.values);
    }

    if (this.values.employees.length == 0) {
      this.showNoDatafound = true;
    } else {
      this.showNoDatafound = false;
    }
  }
  keyupdata(event) {
    if (event.target.value.length == 0) {
      this.onsearch("");
    }
  }
  filterByString(data, s) {
    return data
      .filter((e) => e.userName.toLowerCase().includes(s))
      .sort((a, b) =>
        a.userName.toLowerCase().includes(s) &&
          !b.userName.toLowerCase().includes(s)
          ? -1
          : b.userName.toLowerCase().includes(s) &&
            !a.userName.toLowerCase().includes(s)
            ? 1
            : 0
      );
  }
  employeequary(datas) {
    // this.userData = datas
    this.values.employees = datas;
    this.values.employees = this.sort_by_key(datas, "firstName");
    this.values.employees = [...new Set(this.values.employees)];
    const SuperAdmin = this.values.employees.find(
      (x) => x.businessUserType === "SUPERADMIN"
    );
    if (SuperAdmin) {
      const index = this.values.employees.indexOf(SuperAdmin);
      this.values.employees.splice(index, 1);
      this.values.employees.unshift(SuperAdmin);
    }
    this.values.tempemployees = this.values.employees;
    // this.commonvalues.businessid(this.values);
    // console.log("value is coming ", this.values.employees);
  }

  sortData(data) {
    return data.sort((a, b) => {
      return <any>new Date(b.joinedOn) - <any>new Date(a.joinedOn);
    });
  }

  sort_by_key(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  employees() {

    try {
      this.util.startLoader();
      this.userData = [];
      this.values.employees = [];
      let datas: any = {};
      datas.businessId = this.businessData.businessId;
      this.showNoDatafound = false;
      this.API.setLoadAPIcall(true);
      this.API.create("business/findBusinessEmployees", datas).subscribe(
        (res) => {
          this.API.setLoadAPIcall(false);


          this.showNoDatafound = true;
          this.values.employees = res.data.businessEmployees;
          this.userData = res.data.businessEmployees;
          if (this.userData.length > 0) {
            this.userData.forEach((element) => {
              if (element.userId === localStorage.getItem("userId")) {
                element.joinedOn = new Date();
              }
              element.userName = element.firstName + " " + element.lastName;
              element.type = element.businessUserType;
            })
            this.employeequary(this.userData);
            this.util.stopLoader();
          }

        },
        (err) => {
          this.util.stopLoader();
        }
      );
    } catch (error) {
      this.util.stopLoader();
    }

  }

  sendmsg(data) {
    var userData: any = {};
    userData.userid = data.userId;
    this.router.navigate(["message"], { queryParams: userData });
  }

  userprofile(data) {
    var userData: any = {};
    userData.userId = data;
    this.router.navigate(["personalProfile"], { queryParams: userData });

  }
  connetedstatus(data) { }

  //abu
  formserchData() {
    this.serachForm = this.fb.group({
      serachData: [""],
    });
  }

  userSelected(valUser) {
    var userData: any = {};
    userData.userId = valUser.userId;

    this.router.navigate(["personalProfile"], { queryParams: userData });

  }

  onChangeSearch(val: string) {
    const data: any = {
      businessId: this.businessData.businessId,
      searchText: this.serachForm.value.serachData,
    };

    if (val != null && this.serachForm.value.serachData != "") {
      // console.log('value entered  --> calling api ', this.serachForm.value.serachData);
      this.util.startLoader();
      this.API.create("business/employees/search", data).subscribe(
        (res) => {
          // console.log('business/employees/search',res)
          this.util.stopLoader();
          this.firstList = res.data.businessEmployees;
          this.afterCall();
        },
        (err) => {
          this.util.stopLoader();
        }
      );
    } else if (this.serachForm.value.serachData == "") {
      this.employees();
    }
  }

  afterCall() {
    this.firstList.forEach((response) => {
      this.userList.push(response.userId);
    });
    // console.log(this.userList + "<-----aftercall")
    this.userList.forEach((element) => {
      this.util.startLoader();
      this.API.query("user/connection/" + element).subscribe(
        (res) => {
          this.util.stopLoader();
          this.userData = [];
          this.userData.push({
            userName: res.firstName + " " + res.lastName,
            photo: AppSettings.photoUrl + res.photo,
            organisation: res.organisation,
            title: res.title,
            status: element.status,
            userId: element.userId,
            connected: element.connected,
          });
          this.employeequary(this.userData);
        },
        (err) => {
          this.util.stopLoader();
        }
      );
    });
  }

  delay(callback, ms) {
    var timer = 0;
    return function () {
      var context = this,
        args = arguments;
      clearTimeout(timer);
      var timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

// Emitting the search value to searchSubject. totalCount is NOT zeroed here —
// the count row hides via responseReceived while the (debounced) search call
// is in flight, and shows 0 only when the response really returns 0.
  onSearchEmployee(val : string){
    this.searchSubject.next(val);
  }
 // Triggering scroll event to load more data if stopScroll is false by Naaz
  onScrollDown(){
    if(!this.stopScroll){
      this.loadScroll = true;
      this.scrollSubject.next(this.previouseAfterKey);
    }
  }

  // Send connection request - accessible to both Employee and SuperAdmin
  sendConnectionRequest(user: any) {
    let datas: any = {};
    datas.userId = user.userId;
    datas.requestedBy = this.currentUserId;
    this.util.startLoader();
    
    this.API.create("user/connect", datas).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === "00000") {
        Swal.fire({
          icon: "success",
          title: "Connection request sent successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        // Update the user's connection status
        user.connectionStatus = "REQUEST_SENT";
        user.requestedBy = this.currentUserId;
        this.refreshUserCardButtons();
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Connection request failed. Please try again later.",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }, (err) => {
      this.util.stopLoader();
    });
  }

  // Accept connection request
  acceptConnectionRequest(user: any) {
    let data: any = {};
    data.connectedUser = user.userId;
    data.status = "CONNECTED";
    
    this.util.startLoader();
    this.API.create("user/connect/accept", data).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === "00000") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Connection accepted successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        // Update connection status
        user.connectionStatus = "CONNECTED";
        this.refreshUserCardButtons();
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Failed to accept connection request. Please try again.",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    }, (err) => {
      this.util.stopLoader();
    });
  }

  // Cancel connection request
  cancelConnectionRequest(user: any) {
    let cancelData: any = {};
    cancelData.userId = user.userId;
    
    this.util.startLoader();
    this.API.create("user/connect/cancel", cancelData).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === "00000") {
        Swal.fire({
          icon: "success",
          title: "Connection request cancelled",
          showConfirmButton: false,
          timer: 2000,
        });
        // Update connection status
        user.connectionStatus = "NOT_CONNECTED";
        user.requestedBy = null;
        this.refreshUserCardButtons();
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Oops..",
          text: "Failed to cancel connection request.",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    }, (err) => {
      this.util.stopLoader();
    });
  }

  // Send message to connected user
  sendMessageToUser(user: any) {
    var userData: any = {};
    userData.groupId = user.userId;
    userData.type = "USER";
    this.router.navigate(["message"], { queryParams: userData });
  }

  // Refresh user card buttons based on current state
  refreshUserCardButtons() {
    // Re-initialize user card config based on current filter
    this.applyFilter(this.employeepayload.type);
  }

}

